import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PartnersServiceService } from 'src/app/shared/API-Service/services/partners.service';
import { CompanyTypeService } from 'src/app/shared/API-Service/services/company-type.service';
import Swal from 'sweetalert2';
import {ourPartners} from "../../../../shared/Models/ourPartners";
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-insert-our-partners',
  templateUrl: './insert-our-partners.component.html',
  styleUrls: ['./insert-our-partners.component.css']
})
export class InsertOurPartnersComponent implements OnInit {
  id: string;
  update: boolean;
  insertForm: FormGroup;
  ourPartners = new ourPartners();
  CompanyTypes:any[]=[];
  imageLogo:any
  Image: any;
  Partners: any;
  CreatPartnerForm: any = new FormData();
  BtnDisaple: boolean;

  constructor(private CompanyTypeService:CompanyTypeService, private PartnersService:PartnersServiceService,private _formBuilder: FormBuilder,private router: Router,private route: ActivatedRoute) { 
    this.GetCompanyType();
    this.imageLogo="../../../../../assets/images/upload.png"

  }

  ngOnInit(): void {
    if (this.route.snapshot.paramMap.get("id")) {
      this.id =this.route.snapshot.paramMap.get("id")
      this.PartnersService.GetPartnersByid(this.id).subscribe(async (res:any)=>{
      this.Partners=  await res.data;
      this.imageLogo=environment.ServerImages_URL+'/'+this.Partners.image
        this.initForm(this.Partners);
        
      })
      this.update = true;
    } else {
      this.initForm()
      this.update = false;
    }
  }
  initForm(ourPartners?: ourPartners) {
    this.insertForm = this._formBuilder.group({
      Title: [ourPartners?.title || ''],
      TitleAr: [ourPartners?.titleAr || '', Validators.required],
      CompanyTypeId: [ourPartners?.companyTypeId || '', Validators.required]
    });
  }

  get fc() {
    return this.insertForm.controls;
  }

  GetCompanyType(){
    this.CompanyTypeService.GetCompanyType().subscribe(res=>{
      this.CompanyTypes=res.data;
    })
  }
  Submit(){
    if (this.insertForm.status == "VALID") {
      this.BtnDisaple=true;
      if (this.update == true) {
        
        this.UpdatePartner();
      } else {
        this.InsertPartner();
      }
    }
     else {
      this.insertForm.markAllAsTouched();
    }
  

  }
  UpdatePartner(){
    // const data ={
    //   "id":this.id,
    //   "Title": this.insertForm.get('title').value,
    //   "CompanyTypeId": Number(this.insertForm.get('companyTypeId').value),
    //   "PartnerImage": this.insertForm.get('image').value,
    // }
  
    this.CreatPartnerForm.set('PartnerImage', this.Image)
    this.CreatPartnerForm.set('Title',this.insertForm.get('Title').value)
    this.CreatPartnerForm.set('TitleAr',this.insertForm.get('TitleAr').value)
    this.CreatPartnerForm.set('CompanyTypeId',this.insertForm.get('CompanyTypeId').value)
    this.CreatPartnerForm.set('id',this.id)
    this.PartnersService.UpdatePartner(this.CreatPartnerForm).subscribe(
      (response) => {
      Swal.fire({
      icon: "success",
      title: "تم التعديل بنجاح",
      showConfirmButton: false,
      timer: 1500,
      });
      this.BtnDisaple=false;

      this.router.navigateByUrl("content/admin/OurPartners");
    },
      (err) => {
        this.BtnDisaple=false;

        Swal.fire({
          icon: "error",
          title:err.error.message
          });
      }
  
      );
  }
  InsertPartner(){
    if(this.Image){
         this.CreatPartnerForm.set('PartnerImage', this.Image)
    this.CreatPartnerForm.set('Title',this.insertForm.get('Title').value)
    this.CreatPartnerForm.set('TitleAr',this.insertForm.get('TitleAr').value)
    this.CreatPartnerForm.set('CompanyTypeId',this.insertForm.get('CompanyTypeId').value)


    this.PartnersService.CreatePartner(this.CreatPartnerForm).subscribe(
      (response) => {
      Swal.fire({
      icon: "success",
      title: "تم الحفظ بنجاح",
      showConfirmButton: false,
      timer: 1500,
      });
      this.BtnDisaple=false;

      this.router.navigateByUrl("content/admin/OurPartners");

    },
      (err) => {
        this.BtnDisaple=false;

        Swal.fire({
          icon: "error",
          title:err.error.message
          });
      }
            );
    }
    else{
      this.BtnDisaple=false;

      Swal.fire({
        icon: "error",
        title:"يرجى اختيار الصورة"
        });
    }
 
  }
  OpenImage(imagesView){
    Swal.fire({
      imageUrl: imagesView,
      imageHeight: 400,
      imageAlt: 'A tall image',
      confirmButtonText:"الغاء"
    })
  }
  getLogoUrl(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.Image = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageLogo = reader.result as string;
        // this.logoForm?.set("image", this.Image);
      };
    }
  }
}
